
export const NODE_WIDTH = 192;
export const NODE_HEIGHT = 218;
export const RIGHT_MARGIN = 20;
export const TOP_MARGIN = 34;
export const ARC_SIZE = TOP_MARGIN / 2;
